module.exports = __webpack_public_path__ + "img/image95.3c12da78.png";